import { put, select, takeEvery } from "redux-saga/effects"
import {
  axiosPut,
  delPollsAxios,
  getPollsAxios,
  postPollsAxios,
  getPollsAxiosWithParams,
  putPollsAxios,
} from "helpers/api_helper"
import {
  showSavingModal,
  hideSavingModal,
  putMenuItemSuccess,
  setSelectedFeature,
  setIsOutdated,
} from "../actions"
import {
  addPollFailed,
  addPollSuccess,
  deletePollFailed,
  deletePollSuccess,
  getPollFailed,
  getPollListFailed,
  getPollListSuccess,
  getPollReplyFailed,
  getPollReplySuccess,
  getPollSuccess,
  hideDeletePollModal,
  updatePollFailed,
  updatePollListItemFailed,
  updatePollListItemSuccess,
  updatePollOrderFailed,
  updatePollOrderSuccess,
  updatePollSuccess,
} from "./actions"
import {
  ADD_POLL,
  DELETE_POLL,
  GET_POLL,
  GET_POLL_LIST,
  GET_POLL_REPLY,
  UPDATE_POLL,
  UPDATE_POLL_LIST_ITEM,
  UPDATE_POLL_ORDER,
} from "./actionTypes"

function* addPoll({ payload: { questions, poll } }) {
  try {
    yield put(showSavingModal())
    const questionResponse = yield postPollsAxios("/question", {
      questions,
    })
    const pollResponse = yield postPollsAxios("/poll", {
      ...poll,
      question_id: questionResponse[0].id,
    })
    if (poll.menu_feature) {
      const menuItem = yield axiosPut("/admin/menu-item", {
        entity_id: pollResponse.id,
        menu_item_id: pollResponse.menu_item_id,
      })
      yield put(putMenuItemSuccess(menuItem))
      yield put(setSelectedFeature(menuItem))
      yield put(setIsOutdated(true))
    }
    yield put(addPollSuccess(pollResponse))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(addPollFailed(error))
  }
}

function* getPoll({ payload: params }) {
  try {
    const response = yield getPollsAxios(`/poll/${params}`)
    const destroyed = yield select(state => state.Poll.destroyed)
    if (!destroyed) {
      yield put(getPollSuccess(response))
    }
  } catch (error) {
    yield put(getPollFailed(error))
  }
}

function* updatePoll({ payload: { questions, poll } }) {
  try {
    yield put(showSavingModal())
    const questionResponse = yield putPollsAxios(
      `/question/${questions.id}`,
      questions
    )
    const response = yield putPollsAxios(
      `/poll/${poll.id}`,
      { ...poll, question_id: questionResponse.id },
      {
        params: { menu_item_id: poll.menu_item_id },
      }
    )
    if (poll.menu_feature) {
      yield put(
        getPollSuccess({
          ...poll,
          question_id: questionResponse.id,
          question: questionResponse,
        })
      )
    }
    yield put(updatePollSuccess(response))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(updatePollFailed(error))
  }
}

function* getPollList({ payload: params }) {
  try {
    const response = yield getPollsAxiosWithParams("/poll", { params })
    const destroyed = yield select(state => state.Poll.listDestroyed)
    if (!destroyed) {
      yield put(getPollListSuccess(response))
    }
  } catch (error) {
    yield put(getPollListFailed(error))
  }
}

function* deletePoll({ payload: params }) {
  try {
    const response = yield delPollsAxios(`/poll/${params.pollId}`, {
      menu_item_id: params.menu_item_id,
    })
    yield put(deletePollSuccess(response))
    yield put(hideDeletePollModal())
  } catch (error) {
    yield put(hideDeletePollModal())
    yield put(deletePollFailed(error))
  }
}

function* updatePollListItem({ payload: params }) {
  try {
    const response = yield putPollsAxios(`/poll/${params.id}`, params, {
      params: { menu_item_id: params.menu_item_id },
    })
    yield put(setIsOutdated(true))
    yield put(updatePollListItemSuccess(response))
  } catch (error) {
    yield put(updatePollListItemFailed(error))
  }
}

function* updatePollOrder({ payload: params }) {
  try {
    const response = yield putPollsAxios(`/poll/${params.id}`, params, {
      params: { menu_item_id: params.menu_item_id },
    })
    yield put(updatePollOrderSuccess(response))
  } catch (error) {
    yield put(updatePollOrderFailed(error))
  }
}

function* getPollReply({ payload: params }) {
  try {
    const response = yield getPollsAxios(`/poll/${params?.id}/reply`)
    yield put(getPollReplySuccess(response))
  } catch (error) {
    yield put(getPollReplyFailed(error))
  }
}

function* pollSaga() {
  yield takeEvery(ADD_POLL, addPoll)
  yield takeEvery(GET_POLL, getPoll)
  yield takeEvery(UPDATE_POLL, updatePoll)
  yield takeEvery(GET_POLL_LIST, getPollList)
  yield takeEvery(DELETE_POLL, deletePoll)
  yield takeEvery(UPDATE_POLL_LIST_ITEM, updatePollListItem)
  yield takeEvery(UPDATE_POLL_ORDER, updatePollOrder)
  yield takeEvery(GET_POLL_REPLY, getPollReply)
}

export default pollSaga
